<template>
    <group-details :groupId="props.groupId">
        <div>
            <vx-alert v-if="recentlyCreated" color="success" :closeable="false" class="mb-6" shadow>
                <template v-slot:icon>
                    <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                </template>
                <div class="flex items-center justify-between">
                    <span
                        ><strong>{{ group.name }}</strong> created successfully. Add users below.</span
                    >
                    <vx-button :href="`/settings/teams/${teamId}#/groups`" size="sm" color="success"
                        >Back to Groups <font-awesome-icon widthAuto :icon="faSquareArrowUpLeft"></font-awesome-icon>
                    </vx-button>
                </div>
            </vx-alert>
            <group-user-list
                :groupId="props.groupId"
                :groupName="group.name"
                :teamId="teamId"
                :canManageUsers="canManageUsers"
                :requireSso="requireSso"
            ></group-user-list>
        </div>
    </group-details>
</template>

<script setup>
import GroupDetails from '~/components/settings/teams/groups/form/GroupDetails.vue';
import GroupUserList from '~/components/settings/teams/groups/form/users/GroupUserList.vue';
import { VxAlert, VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';
import dayjs from '~/utils/dayjs';
import { useGroupDetails } from '../useGroupDetails';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { faCircleCheck, faSquareArrowUpLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const teamId = Spark.state.currentTeam.id;
const requireSso = Boolean(Spark.state.currentTeam.require_sso);
const { group } = useGroupDetails();
const { onCorporate, roleOnCurrentGroup } = useCurrentGroup();

const canManageUsers = computed(() => onCorporate() || ['admin', 'owner'].includes(roleOnCurrentGroup));

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    },
});

const recentlyCreated = computed(() =>
    group.value.created_at ? dayjs.utc(group.value.created_at).isAfter(dayjs().subtract(15, 'seconds')) : false
);
</script>
